"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiSelectOverrides = {
    MuiSelect: {
        styleOverrides: {
            root: () => ({
                lineHeight: '1.5rem',
            }),
            icon: ({ theme }) => ({
                color: theme.palette.gray[700],
            }),
        },
    },
};
exports.default = MuiSelectOverrides;
//# sourceMappingURL=MuiSelectOverrides.js.map